import { render, staticRenderFns } from "./SupplierCreateForm.vue?vue&type=template&id=4d1c974f"
import script from "./SupplierCreateForm.vue?vue&type=script&lang=js"
export * from "./SupplierCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports